import { isFansidedProperty } from '../store/config/config.utils';

export const hasOAuth = (
  type: 'google-oauth' | 'microsoft-oauth',
  propertyEndpoint?: string,
  experiments?: string[],
  edition?: string,
  isFannation = false,
): boolean => {
  if (!propertyEndpoint || !edition) return false;

  const hasSuppressedExperiment = experiments?.some(experiment => experiment.includes('google-oauth') && experiment.includes('suppression'));

  if (hasSuppressedExperiment) return false;

  const hasExperiment = experiments?.some(
    experiment => (experiment.includes(type) && experiment.includes('modal'))
  );

  // This will contain more properties as needed.
  const properties = ['www.si.com', 'mentalfloss.com', 'swimsuit.si.com'];
  // It's safe to check if edition is a number (FanSided sites) because Google One Tap
  // will not work unless the site is configured properly in the Google Console.
  // exclude 229 FanSided, 16 BuffaLowDown, and 30 TheJetPress
  const isFansidedNetwork = isFansidedProperty(edition) && !['229', '16', '30'].includes(edition);

  if (type === 'google-oauth') {
    return (
      hasExperiment
      || properties.some(property => propertyEndpoint.includes(property))
      || isFannation
      || isFansidedNetwork
    );
  }
  // microsoft-oauth
  if (type === 'microsoft-oauth') {
    return (
      hasExperiment
      || propertyEndpoint.includes('www.si.com')
      || isFannation
    );
  }

  return false;
};
